export const RUNTIME_MODES = {
    DEV: 'dev',
}

export const TERMINAL_MODES = {
    CAPTURE_PAYMENT: 'capturePayment',
    ADD_PAYMENT_METHOD: 'addPaymentMethod',
}
